<template>
    <div class="public_header ">
        <div class="public_img">
            <img src="../assets/wiccoLogo2.png" alt="Logo" class="logo">
        </div>


        <ul class="custom-nav" :class="{ show: menuOpen }">
            <li><router-link to="/">Accueil</router-link></li>
            <li><router-link to="/public/boisDeChauffage">Bois de chauffage</router-link></li>
            <li><router-link to="/public/boisDAllumage">Bois d'allumage</router-link></li>
            <li><router-link to="/public/Grume">Grume</router-link></li>
            <li><router-link to="/public/contact">Contact</router-link></li>
            <li><router-link to="/admin/dashboard">Admin</router-link></li>
        </ul>

        <div class="burger" @click="toggleMenu">
            ☰
        </div>
    </div>
</template>

<script>
export default {
    name: 'publicHeader',
    data() {
        return {
            menuOpen: false
        };
    },
    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        }
    }
};
</script>

<style>
.public_header {
    display: flex;
    background-color: #cf945d;
    color: #143D60;
    font-weight: bold;
    justify-content: space-between;
    padding: 10px 20px;
    position: relative;
    align-items: center;
    z-index: 1;
}

.logo {
    width: 120px;
}

.custom-nav {
    display: flex;
    flex-direction: row;
    list-style: none;
    gap: 20px;
    margin: 0;
    padding: 0;
}

.custom-nav li {
    position: relative;
}

.custom-nav a {
    text-decoration: none;
    color: #143D60;
    font-weight: 500;
    padding: 8px 15px;
    border-radius: 5px;
    transition: all 0.3s ease;
}

.custom-nav a:hover {
    background: #143D60;
    color: #fff;
}

.custom-nav .router-link-exact-active {
    background: #143D60;
    color: white;
    font-weight: 600;
}

.burger {
    display: none;
    font-size: 28px;
    cursor: pointer;
    color: #143d60;
    position: relative;
    z-index: 10;
}

/* Responsive - Menu burger */
@media screen and (max-width: 768px) {
    .burger {
        display: block;
    }

    .custom-nav {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 60px;
    right: 10px;
    background: #cf945d;
    width: 200px;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    gap: 10px;
  }

  .custom-nav.show {
    display: flex; 
  }
}
</style>
